import React from 'react'

import Alert from 'common/components/alert'
import SingleSelect from 'common/components/singleSelect'
import Spinner from 'common/components/spinner'
import { stringToNumber } from 'common/helpers/numeric'

import { SplitSizeData } from '../interface'

interface ISplitSize {
  splitSizeObject: SplitSizeData
  processing: boolean
  disabled?: boolean
  selectedSplitNumber?: number
  updateSplitSizeNumber: (splitNumber: number) => void
}

const SplitSize: React.FC<ISplitSize> = ({
  processing,
  splitSizeObject,
  updateSplitSizeNumber,
  disabled = false,
  selectedSplitNumber,
}) => {
  // render will know everything!
  const {
    headline,
    show_other_split_options,
    other_split_options,
    split_result,
    warning,
  } = splitSizeObject

  return (
    <React.Fragment>
      {processing ? (
        <div style={{ height: '179px' }} className="w-156">
          <Spinner isSpinning={processing} />
        </div>
      ) : (
        <div className="p-6 border border-orange-400 rounded-md bg-coolGray-50">
          <span
            data-test-id="splitsize-headline"
            className="mr-2 text-coolGray-700 font-medium"
          >
            {headline}
          </span>
          <span
            className="text-base font-bold text-orange-500"
            data-test-id="informations-container"
          >
            {split_result}
          </span>
          {warning && (
            <Alert type="warn" className="mt-6" showIcon={true}>
              {warning}
            </Alert>
          )}
          {show_other_split_options ? (
            <React.Fragment>
              <p className="pt-6 pb-5 text-coolGray-500">
                Unable to test the recommended number of splits? No problem.
              </p>

              <div className="flex items-center font-medium">
                <p>Select the right number</p>
                <SingleSelect
                  size="large"
                  className="regular w-24 ml-4"
                  isDisabled={disabled}
                  onChange={(val) => {
                    updateSplitSizeNumber(stringToNumber(val?.value) ?? 0)
                  }}
                  value={selectedSplitNumber?.toString()}
                  menuPlacement="top"
                  placeholder="Select an option"
                  options={other_split_options.map((option: number) => ({
                    label: option.toString(),
                    value: option.toString(),
                  }))}
                />
              </div>
            </React.Fragment>
          ) : null}
        </div>
      )}
    </React.Fragment>
  )
}

export default SplitSize
